import { Reducer, Action } from 'redux'
import { IShipment } from 'types/shipment'
import { SHIPMENT_ACTION_TYPES } from '../actions/shipment'

const { SHIPMENT_FAILURE, SHIPMENT_REQUEST, SHIPMENT_SUCCESS } = SHIPMENT_ACTION_TYPES

export interface IShipmentState {
  fetching: boolean
  error?: string
  shipment?: IShipment
}
interface ShipmentSuccessAction extends Action<string> {
  payload: {
    shipment: IShipment
  }
}
interface ShipmentFailureAction extends Action<string> {
  error: string
}

type ShipmentReducerAction = Action<string> | ShipmentSuccessAction | ShipmentFailureAction

const defaultState = {
  fetching: false,
  error: undefined,
  shipment: undefined,
} as IShipmentState

const shipmentReducer: Reducer<IShipmentState, ShipmentReducerAction> = (
  state = defaultState,
  action
) => {
  if (!action) return state

  switch (action.type) {
    case SHIPMENT_REQUEST:
      return {
        ...state,
        fetching: true,
        error: undefined,
      }

    case SHIPMENT_SUCCESS: {
      const {
        payload: { shipment },
      } = action as ShipmentSuccessAction
      return {
        ...state,
        fetching: false,
        error: undefined,
        shipment,
      }
    }

    case SHIPMENT_FAILURE: {
      const { error } = action as ShipmentFailureAction
      return {
        ...state,
        fetching: false,
        error,
      }
    }

    default:
      return state
  }
}

export default shipmentReducer
